import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Icon } from '@material-ui/core';
import SubscriptionTierForm from './SubscriptionTierForm';
import TiersList from './TiersList';


const StoreSubscriptionPlans = () => {
  const [tier, setTier] = useState();
  const {profile} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25 my-4 ml-10 pr-10">
      {tier ?
        <SubscriptionTierForm tier={tier} setTier={setTier} />
        :
        <>
          {permissions?.adminSubscriptionTierAdd &&
          <Button
            color="primary"
            variant="contained"
            onClick={() => setTier({})}
            className="mb-8"
          >
            <Icon className="mr-2">add</Icon>
            <span>Add New Tier</span>
          </Button>}
          <TiersList setTier={setTier} />
        </>
      }
    </div>
  );
};

export default StoreSubscriptionPlans;
